
export default {
  upload_failed: 'Failed to upload document',
  confirm_upload: `You WON'T be able to delete or edit it later. Anyone will have a possibility to see and
                   download this document and it's name will be visible to everyone, so please ensure all is valid.`
}



// WEBPACK FOOTER //
// ./src/js/i18n/to_replace/documens.js